import Button from 'components/core/button'
import IconButton from 'lib/components/buttons/icon-button'
import Modal, { BaseModalProps } from 'lib/components/modals/modal'
import { X } from 'lucide-react'
import BillingModalPeriod from './billing-modal-period'
import BillingModalPlatform from './billing-modal-platform'
import BillingModalProfessionalServices from './billing-modal-professional-services'
import BillingModalCreativeServices from './billing-modal-creative-services'

export default function BillingModal({
  open,
  setOpen,
}: {
  open: BaseModalProps['open']
  setOpen: BaseModalProps['setOpen']
}) {
  return (
    <Modal open={open} setOpen={setOpen} size="lg">
      <Modal.Header as="div">
        <div className="tw-flex tw-items-center tw-justify-between">
          <h4>Manage Your Subscription</h4>
          <IconButton color="secondary" onClick={() => setOpen(false)} data-testid="close-modal-button">
            <X />
          </IconButton>
        </div>
      </Modal.Header>

      <Modal.Body>
        <div className="tw-flex tw-flex-col tw-gap-4">
          <BillingModalPeriod />
          <BillingModalPlatform />
          <div className="tw-font-semibold">Services</div>
          <BillingModalCreativeServices />
          <BillingModalProfessionalServices />
        </div>
      </Modal.Body>

      <Modal.Footer>
        <div className="tw-mt-8 tw-flex tw-w-full tw-justify-between">
          <Button color="neutral" onClick={() => console.log('Cancel subscription')}>
            Cancel Subscription
          </Button>
          <div className="tw-flex tw-justify-end">
            <Button
              color="neutral"
              onClick={() => {
                setOpen(false)
              }}
              className="tw-mr-2"
            >
              Cancel
            </Button>
            <Button
              color="purple"
              onClick={() => {
                console.log('Review changes')
              }}
            >
              Review changes
            </Button>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  )
}
